import { reactive } from 'vue'
import { FormPropertyType, InstallationType } from '@/helper/Types'

class FormStore {
  private _data: Partial<FormPropertyType> = {}
  private _initialData: Partial<FormPropertyType> = {}
  private _forceSave = false

  get data(): Partial<FormPropertyType> {
    return this._data
  }

  set data(value: Partial<FormPropertyType>) {
    this._data = value
  }

  get initialData(): Partial<FormPropertyType> {
    return this._initialData
  }

  set initialData(value: Partial<FormPropertyType>) {
    this._initialData = value
  }

  get forceSave(): boolean {
    return this._forceSave
  }

  set forceSave(value: boolean) {
    this._forceSave = value
  }

  get isHeating(): boolean {
    return (this.data.installationTypes as string[]).includes(InstallationType.HEATING)
  }

  get isCooling(): boolean {
    return (this.data.installationTypes as string[]).includes(InstallationType.COOLING)
  }
}

const formStore = reactive(new FormStore())
export default formStore
